module.exports = "/build/images/icons-public.710f506a.svg";